(function () {
  function buildTabNav(root) {
    var nav = root.querySelector('[data-news-info-tabs-nav]');
    if (!nav) return;

    nav.innerHTML = '';

    root.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      var inputId = panel.dataset.tabInputId;
      var title = panel.dataset.tabTitle;
      if (!inputId || !title) return;

      var li = document.createElement('li');
      var label = document.createElement('label');
      label.htmlFor = inputId;
      label.className = 'fpt__tab-item-label news-info-tabs__tab-label';
      label.textContent = title;
      li.appendChild(label);
      nav.appendChild(li);
    });
  }

  function bindTabChange(root) {
    var sectionId = root.dataset.sectionId;
    if (!sectionId || root.dataset.tabChangeBound === 'true') return;
    root.dataset.tabChangeBound = 'true';

    root.querySelectorAll('input[name="news-tab-input-' + sectionId + '"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('news-info-tabs:tab-change'));
        });
      });
    });
  }

  function initNewsInfoTabs(root) {
    buildTabNav(root);
    bindTabChange(root);
  }

  function initAll() {
    document.querySelectorAll('[data-news-info-tabs]').forEach(initNewsInfoTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-news-info-tabs]');
    if (!root) return;

    initNewsInfoTabs(root);
    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event('news-info-tabs:tab-change'));
    });
  });
})();
